import React, { useEffect, useState } from "react"
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logIn, logInOrSignUp, signUp } from "../../store/reducers/authReducer";
import { AppButton } from "../common/button/AppButton";
import { Centered } from "../common/centered/Centered";
import { AppInput } from "../common/input/AppInput";
import { AppLink } from "../common/link/AppLink";
import styles from './Auth.module.css'

export const Auth = () => {
    const { register, reset, watch, handleSubmit, formState: { errors } } = useForm();
    const [isSigned, setIsSigned] = useState(false)
    const [isDisabled, setIsdisabled] = useState(true)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        const subscription = watch(value => setIsdisabled(Object.values(value).some(field => field === '')))
        return () => subscription.unsubscribe()
    }, [watch])

    const onSubmit = async (formData) => {
        const email = formData.email
        const password = formData.password

        let action

        try {
            if (isSigned) {
                action = logInOrSignUp('signup', email, password)
                // action = signUp(email, password)
            } else {
                action = logInOrSignUp('login', email, password)
                // action = logIn(email, password)
            }
            await dispatch(action)
            reset()
            navigate('/')
        } catch (e) {
            switch (e.code) {
                case 'auth/wrong-password':
                case 'auth/user-not-found':
                case 'auth/user-cancelled':
                    alert('Wrong password or e-mail, pal...')
                    break
                case 'auth/weak-password':
                    alert('Weak password, bro...')
                    break
                default:
                    alert(e.code)
                    break
            }
        }
    }

    const goBackHandler = () => {
        navigate(-1)
    }

    return <Centered>
        <div className={styles.auth}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <AppInput
                        register={register}
                        field='email'
                        type='email'
                        placeholder='your e-mail'
                        value=''
                    />
                </div>
                <div>
                    <AppInput
                        register={register}
                        field='password'
                        type='password'
                        placeholder='your password'
                        value=''
                    />
                </div>
                <AppButton
                    disabled={isDisabled}
                    type='submit'
                    value={isSigned ? 'Sign Up' : 'Log In'} />
                <AppButton
                    type='button'
                    onClick={() => setIsSigned(prevState => !prevState)}
                    value={`Switch to ${isSigned ? 'Log In' : 'Sign Up'}`} />
            </form>
            <AppLink action={goBackHandler}>Go Back</AppLink>
        </div>
    </Centered>
}